import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const isTypingTarget = (t) =>
  t && (t.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(t.tagName));

export function useAdminShortcut() {
  const navigate = useNavigate();
  useEffect(() => {
    const onKey = (e) => {
      if (!(e.ctrlKey || e.metaKey) || !e.shiftKey || e.key?.toLowerCase() !== "a") return;
      if (isTypingTarget(e.target)) return;
      e.preventDefault();
      navigate("/admin/login");
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);
}
